import axios from 'axios';

const apiRoute = 'https://tr.jianshu.com/fe/1/log';

const path =
  window.location.pathname === '/'
    ? '/index'
    : window.location.pathname;

const logger = {
  addLog(data = {}) {
    const logData = Object.assign({}, {
      index: 'front-end-log',
      app: 'martin',
      level: 'info',
      time: +(+new Date() / 1000).toFixed(0),
      path,
      url: window.location.href.split('?')[0],
      ua: navigator.userAgent,
    }, data);
    try {
      axios.post(apiRoute, logData);
    } catch (e) {
      console.log(e);
    }
  },
};

export default logger;



// WEBPACK FOOTER //
// ./src/utils/logger.js